export { InputLabel } from "./input-label";
